import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { EditorField } from "../../store";

interface DraggableSidebarItemProps {
  type: EditorField["type"];
  label: string;
  systemKey?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

export const DraggableSidebarItem: React.FC<DraggableSidebarItemProps> = ({
  type,
  label,
  systemKey,
  icon,
  disabled = false,
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `sidebar-${type}-${systemKey || "custom"}`,
    data: {
      type,
      label,
      systemKey,
      isSidebarItem: true,
    },
    disabled,
  });

  const style: React.CSSProperties = {
    opacity: disabled ? 0.5 : isDragging ? 0.4 : 1,
    cursor: disabled ? "not-allowed" : "move",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(disabled ? {} : listeners)}
      {...attributes}
      className={`p-3 border rounded shadow-sm transition-colors flex items-center gap-2 ${
        disabled
          ? "bg-gray-50 border-gray-100 text-gray-400"
          : "bg-white hover:border-indigo-500 cursor-move"
      }`}
    >
      <div
        className={`p-1 rounded ${disabled ? "bg-transparent" : "bg-gray-100"}`}
      >
        {icon ? (
          icon
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="9" cy="12" r="1" />
            <circle cx="9" cy="5" r="1" />
            <circle cx="9" cy="19" r="1" />
            <circle cx="15" cy="12" r="1" />
            <circle cx="15" cy="5" r="1" />
            <circle cx="15" cy="19" r="1" />
          </svg>
        )}
      </div>
      <s-text color={disabled ? "subdued" : "base"}>{label}</s-text>
    </div>
  );
};
